export default __webpack_public_path__ + "static/media/video-tutorial.18625c10.svg";